import { FaGithub } from "react-icons/fa";
import DarkWave from "../Waves/DarkWave";
import "./ProjectLight.css";
// import "./ProjectDark.css"
import zoomcar_pic from "../../images/quiz.png";

function Project1({ id }) {
  return (
    <article id={id} className="project light">
      <h2 className="project__header">Projects</h2>
      <div className="project__main">
        <img
          className="project__image"
          src={zoomcar_pic}
          srcset={zoomcar_pic}
          sizes="50vw"
          alt="Zoomcar Landing Page"
          width="50%"
          height="auto"
          loading="lazy"
        />
        <div data-aos="fade-left" className="project__right">
          <h3 className="project__title">Quiz app in React.js</h3>
          <p className="project__description project__body">
            A 22 category quiz application in React.Js in which user can select category and 
            medium and start quiz.
          </p>
          <p className="project__tech project__body">
            &gt; . React.js . MaterialUI .
          </p>
          <div className="code_url_div"  >
          <a
            className="project__sourceCode"
            href="https://github.com/Keshav-babu/quizApplication.git"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="=Website GitHub Repository"
          >
            <FaGithub className="project__githubLogo" size={25} />
            <h3 className="project__sourceCodeText">Source Code</h3>
          </a>
          <a
            className="project__sourceCode"
            href="https://quiz-application-theta.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="=Website GitHub Repository"
          >
            <FaGithub className="project__githubLogo" size={25} />
            <h3 className="project__sourceCodeText">View Project</h3>
          </a>
          </div>

          
        </div>
      </div>
      <DarkWave />
    </article>
  );
}

export default Project1;
